// Internal dependencies
import { getBlockLabelByName } from '@helpers/utils';
import LinkAttributes from '@components/link/attributes.json';
import icons from './icons';
import transforms from './transforms';
import { DEFAULT_CSS_CLASS } from '@constants';
import blockEditorView from './edit';

const {
  blocks: { registerBlockVariation },
  hooks: { addFilter },
} = wp;

// Enable extended attributes on the following blocks
const enableExtendedAttributesOnBlocks = ['core/image'];

/**
 * Add extended attributes attribute to block.
 *
 * @param {Object} settings Current block settings.
 * @param {string} name     Name of block.
 *
 * @return {Object} Modified block settings.
 */
const addExtendedAttributes = (settings, name) => {
  // Do nothing if it's another block than our defined ones.
  if (!enableExtendedAttributesOnBlocks.includes(name)) {
    return settings;
  }

  const extendedSettings = {
    ...settings,
    transforms,
    attributes: {
      ...settings.attributes,
      ...LinkAttributes,
      useExtendedAttributes: {
        type: 'boolean',
        default: false,
      },
      label: {
        type: 'string',
        default: '',
      },
      blockVisibility: {
        type: 'boolean',
        default: true,
      },
      blockClassNames: {
        type: 'array',
        default: [{ value: `${DEFAULT_CSS_CLASS.IMAGE}--dlt`, label: 'Dlt' }],
      },
      enableLink: {
        type: 'boolean',
        default: false,
      },
    },
    __experimentalLabel: (attributes) =>
      getBlockLabelByName(attributes, settings.title),
    supports: {
      ...settings.supports,
      anchor: false,
      color: {
        background: false,
        gradients: false,
        text: false,
      },
      filter: {
        duotone: false,
      },
      __experimentalBorder: false,
    },
    usesContext: [
      'allowResize',
      'imageCrop',
      'fixedHeight',
      'b3rg/disableNestedLink',
    ],
    styles: [],
  };
  return extendedSettings;
};

addFilter(
  'blocks.registerBlockType',
  'b3rg/add-extended-attributes',
  addExtendedAttributes,
);

/**
 * Passing a Higher Order Component through a filter to add extended attributes.
 */
addFilter('editor.BlockEdit', 'b3rg/with-extended-attributes', blockEditorView);

// Registering the block variation
registerBlockVariation('core/image', {
  name: 'b3rg/image',
  title: 'Image',
  description:
    'Easily insert and customize images to enrich your content visually.',
  icon: icons.imageIcon,
  isActive: ['useExtendedAttributes'],
  attributes: {
    useExtendedAttributes: true,
    blockVisibility: true,
    blockClassName: '',
  },
});
